import {GET_TITLE, GET_TITLE_SUCCESS, GET_TITLE_FAILURE} from '../constants'


const initialState = {
    isFetching: false,
    error: false
};


export default (state = initialState, action) => {
    switch(action.type) {
        case GET_TITLE:
            return {
                ...state,
                [action.url]:{
                    isFetching: true
                }
            };
        case GET_TITLE_SUCCESS:
            let newState = Object.assign({}, state);
            newState[action.url].title = action.result.title
            newState[action.url].isFetching = false
            return newState;
        case GET_TITLE_FAILURE:
            let errorState = Object.assign({}, state);
            errorState[action.url].error = action.error
            errorState[action.url].isFetching = false
            return errorState;
        default:
            return state;
    }
};


// WEBPACK FOOTER //
// ./src/reducers/title.js